import React from 'react'

import './forms.css'

const Message = (props) => {
	return (
		<p className="validation-message">{props.message}</p>
	)
}
const MessageMockup = (props) => {
	return (
		<p className="validation-message">&nbsp;</p>
	)
}

const Component = (props) => {
  return (
  	<div className="form-group">
			{ props.children }
			{ props.message ?
					<Message message={props.message} /> :
					<MessageMockup />
			}
  	</div>
  )
}

export default Component